import { Box, Button, Modal, TextField } from '@mui/material';
import React, { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { addUserAsync, SelectIsLoading, selectAddUserModalShow, setAddUserModalShow, setUpdateFlag } from '../features/authentication/authenticationSlice';
import { loginModalStyle, userInterface } from '../app/consts';
import { toast } from 'react-toastify';

const RegisterUser = () => {
    const dispatch = useAppDispatch();
    const addUserModalShow = useAppSelector(selectAddUserModalShow);
    const isLoading = useAppSelector(SelectIsLoading);

    const [password, setPassword] = useState("")
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [phoneNum, setPhoneNum] = useState("")
    const [FirstNameValid, setFirstNameValid] = useState<boolean>(true)
    const [LastNameValid, setLastNameValid] = useState<boolean>(true)
    const [PasswordValid, setPasswordValid] = useState<boolean>(true)
    const [PhoneNumberValid, setPhoneNumberValid] = useState<boolean>(true)
    const [FirstNameHelper, setFirstNameHelper] = useState('')
    const [LastNameHelper, setLastNameHelper] = useState('')
    const [passwordHelper, setPasswordHelper] = useState('')
    const [PhoneNumberHelper, setPhoneNumberHelper] = useState('')

    const validateFirstName = (firstName: string) => {
        if (firstName === "") {
            setFirstNameHelper("")
            setFirstNameValid(true)
            return
        }
        const reg = new RegExp("^[א-ת]+( {0,1}[א-ת]+)*$");
        const isValid = reg.test(firstName);
        if (isValid === false) {
            setFirstNameValid(false)
            setFirstNameHelper("שם פרטי חייב להיות בעברית, ללא תווים מיוחדים וללא רווח בהתחלה או בסוף")
        }
        else {
            setFirstNameValid(true)
            setFirstNameHelper("")
        }
        setFirstName(firstName)
    }

    const validateLastName = (lastName: string) => {
        if (lastName === "") {
            setLastNameHelper("")
            setLastNameValid(true)
            return
        }
        const reg = new RegExp("^[א-ת]+( {0,1}[א-ת]+)*$");
        const isValid = reg.test(lastName);
        if (isValid === false) {
            setLastNameValid(false)
            setLastNameHelper("שם פרטי חייב להיות בעברית, ללא תווים מיוחדים וללא רווח בהתחלה או בסוף")
        }
        else {
            setLastNameValid(true)
            setLastNameHelper("")
        }
        setLastName(lastName)
    }

const validatePhoneNumber = (phoneNum: string) => {
    if (phoneNum === "") {
      setPhoneNumberHelper("נא להזין מספר טלפון")
      setPhoneNumberValid(false)
      return
    }
    const reg = new RegExp("^05\\d{8}$");
    const isValid = reg.test(phoneNum);
    if (isValid === false) {
      setPhoneNumberValid(false)
      setPhoneNumberHelper("מספר הטלפון חייב להתחיל ב-05 ולהכיל בדיוק 10 ספרות")
    }
    else {
      setPhoneNumberValid(true)
      setPhoneNumberHelper("")
    }
    setPhoneNum(phoneNum)
  }

    const handleSubmit = () => {
        let isErrorExist = false;
        const form = !document.querySelector<HTMLInputElement>('form[id="addUser"]')?.checkValidity() as boolean
        isErrorExist = (form || FirstNameValid === false || LastNameValid === false || PasswordValid === false || PhoneNumberValid === false);

        if (isErrorExist === true)
            toast.error("קיימת טעות/חסר מידע בטופס");
        else {
            const usr: userInterface = { "first_name": firstName, "last_name": lastName, "email": email, "phone_num":phoneNum, "username": email, "password": password, }
            dispatch(addUserAsync(usr)).unwrap().then(() => {
                dispatch(setUpdateFlag())
                dispatch(setAddUserModalShow(false))
            })
                .catch(() => { })
        }
    }

    const validatePassword = (password: string) => {
        if (password === "") {
            setPasswordHelper("נא להזין סיסמא")
            setPasswordValid(true)
            return
        }
        let errorMSG = "";
        const rules = [
            { regex: /^\S+$/, message: "הסיסמא לא יכולה להכיל רווחים." },
            { regex: /[A-Za-z]/, message: "הסיסמא חייבת להכיל לפחות אות אחת באנגלית." },
            { regex: /[0-9]/, message: "הסיסמא חייבת להכיל לפחות ספרה אחת." },
            // eslint-disable-next-line
            { regex: /[!@#$%^&*()_\+\-=]/, message: "הסיסמא חייבת להכיל לפחות תו מיוחד אחד." },
            { regex: /^.{8,}$/, message: "הסיסמא חייבת להיות באורך של לפחות 8 תווים." }
        ];

        const errorList = rules.filter(rule => !rule.regex.test(password));
        errorList.forEach((rule) => errorMSG += rule.message + '\n')

        if (errorList.length === 0) {
            setPasswordValid(true)
            setPassword(password)
            setPasswordHelper("")
        }
        else setPasswordValid(false)
        setPasswordHelper(errorMSG)
    }


    return (
        <div>
            <Modal
                open={addUserModalShow}
                onClose={() => dispatch(setAddUserModalShow(false))}>
                <Box sx={loginModalStyle}>
                    {isLoading ?
                        <img src='/FadingCircles.gif' alt='spinner' />
                        :
                        <form method='POST' id='addUser' style={{ textAlign: 'center', fontSize: '30px' }} onSubmit={(e) => e.preventDefault()}>
                            <p>אנא הזן את פרטי המשתמש החדש</p>
                            <TextField variant="filled" label='שם פרטי' type='text' onChange={(e) => validateFirstName(e.target.value)} error={!FirstNameValid} helperText={FirstNameHelper} required style={{ fontSize: '20px', width: '80%', textAlign: 'center' }} autoComplete='given-name'/>
                            <br /><br />
                            <TextField variant="filled" label='שם משפחה' type='text' onChange={(e) => validateLastName(e.target.value)} error={!LastNameValid} helperText={LastNameHelper} required style={{ fontSize: '20px', width: '80%', textAlign: 'center' }} autoComplete='family-name'/>
                            <br /><br />
                            <TextField variant="filled" label='דוא"ל' type='email' onChange={(e) => {setEmail(e.currentTarget.value)}} required style={{ fontSize: '20px', width: '80%', textAlign: 'center' }} autoComplete='email'/>
                            <br /><br />
                            <TextField variant="filled" label='מספר טלפון נייד' type='text' onChange={(e) => validatePhoneNumber(e.target.value)} error={!PhoneNumberValid} helperText={PhoneNumberHelper} required style={{ fontSize: '20px', width: '80%', textAlign: 'center' }} autoComplete='tel'/>
                            <br /><br />                            
                            <TextField variant="filled" label='סיסמא' type='password' onChange={(e) => validatePassword(e.currentTarget.value)} error={!PasswordValid} helperText={passwordHelper} required style={{ fontSize: '20px', width: '80%', textAlign: 'center', whiteSpace: 'pre-wrap' }} autoComplete="new-password"/>
                            <br /><br />
                            <Button
                                type='submit'
                                onClick={(e) => handleSubmit()}
                                variant="contained"
                                size='large' color='success'>הוסף</Button>
                        </form>
                    }
                </Box>
            </Modal>
        </div>
    )
}

export default RegisterUser